import Player from '@vimeo/player';
import loadYouTubeAPI from '../utilities/youtube-api.js';

const initVideoEmbed = (elements) => {
    const playVideo = (event, el, player, type) => {
        event.preventDefault();
        el.classList.add('playing');

        if (type === 'vimeo') {
            player.play();
        } else {
            player.playVideo();
        }
    };

    const initPlayer = async (el, type) => {
        const video = el.querySelector('.js-video-iframe');
        const openBtns = el.querySelectorAll('.js-play-video');

        let player;

        if (type === 'youtube') {
            const YT = await loadYouTubeAPI();
            player = new YT.Player(video);
        } else {
            player = new Player(video);
        }

        openBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                playVideo(event, el, player, type);
            });
        });
    };

    elements.forEach((el) => {
        const embedType = el.dataset.videoEmbed;
        initPlayer(el, embedType);
    });
};

export default initVideoEmbed;
